// extracted by mini-css-extract-plugin
module.exports = {"heroList":"heroList_heroList__O1LgZ","hero":"heroList_hero__KS7pC","title":"heroList_title__kgHAj","description":"heroList_description__tViBp"};